import Vue from "vue";
import SocialMediaSharing from "./SocialMediaSharing.vue";

export function load() {
  const selector = "social-media-component";
  // Is the custom Vue root element in the DOM?

  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(SocialMediaSharing, {
        props: {
          ...window[selector]
        }
      })
  }).$mount(selector);
}
